module.exports = __webpack_public_path__ + "static/aquaponics-07e84264c605d0673d7cf0fe5a5726f9.jpg";